import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch, parseJsonSafe, handleUnauthorized } from '../../utils/api';

const ClientWhatsappTab = ({ clientId, onChanged }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!clientId) return;
    setLoading(true);
    setError('');
    try {
      const res = await apiFetch(`/api/whatsapp/conversations?clientId=${clientId}&limit=50`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await parseJsonSafe(res);
      if (res.status === 401) return handleUnauthorized();
      if (!res.ok) throw new Error(data.message || 'Error cargando conversaciones');
      setRows(Array.isArray(data) ? data : (data.items || []));
      if (onChanged) onChanged();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [clientId, token, onChanged]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="text-muted">Cargando…</div>;
  if (error) return <div className="alert alert-danger">{error}</div>;

  if (!rows.length) {
    return (
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="text-muted">Este cliente no tiene conversaciones de WhatsApp vinculadas.</div>
          <div className="small text-muted mt-2">Las conversaciones se crean cuando el cliente escribe a tu número WhatsApp Business. Puedes enlazar manualmente una conversación desde la pestaña de WhatsApp.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm">
      <div className="card-body p-0">
        <table className="table table-sm mb-0">
          <thead>
            <tr>
              <th>Teléfono / Contacto</th>
              <th>Último mensaje</th>
              <th>Fecha</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const id = r.conversationId || r.id;
              const label = r.contact_name || r.name || r.contact || r.phone;
              const body = r.lastBody || r.last_body || '';
              const date = r.lastDate || r.last_date || r.last_message_at;
              const unread = Number(r.unread || 0);
              return (
                <tr key={id}>
                  <td>
                    <div className="fw-semibold">{label}</div>
                    <div className="text-muted small">{r.phone || r.contact}</div>
                  </td>
                  <td style={{ maxWidth: 400 }} className="text-truncate">{body || '—'}</td>
                  <td className="small text-muted">{date ? new Date(date).toLocaleString() : '—'}</td>
                  <td className="text-end">
                    {unread > 0 && <span className="badge bg-danger me-2">{unread}</span>}
                    <button className="btn btn-sm btn-outline-primary" onClick={() => navigate(`/whatsapp?chatId=${id}`)}>
                      Abrir chat
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientWhatsappTab;
